import { render } from "./GradeForm.vue?vue&type=template&id=662d3ddf"
import script from "./GradeForm.vue?vue&type=script&lang=js"
export * from "./GradeForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__